"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _commonMultiCarousel = _interopRequireDefault(require("../styles/common-multi-carousel.css"));
var CommonMultiCarouselButton = function CommonMultiCarouselButton(_ref) {
  var handlerFunction = _ref.handlerFunction,
    label = _ref.label;
  return /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: _commonMultiCarousel["default"].mmcIconCarouselArrow,
    onClick: function onClick() {
      return handlerFunction();
    },
    id: label,
    "aria-label": label
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _commonMultiCarousel["default"].visuallyHidden
  }, label));
};
var _default = CommonMultiCarouselButton;
exports["default"] = _default;